import { ERROR_CODES } from 'vio-constants';
import { getAxiosResponseInterceptors } from 'vio-libs';
import store from '../store';
import { initializeResponseInterceptors, setUnauthorized } from './slice';
export function setAxiosResponseInterceptors() {
    const { dispatch } = store;
    const responseInterceptor = getAxiosResponseInterceptors();
    dispatch(initializeResponseInterceptors());
    responseInterceptor.use(function (response) {
        return response;
    }, function (error) {
        const { response = {} } = error;
        const { status = 0 } = response;
        if (status === ERROR_CODES.UNAUTHORIZED) {
            dispatch(setUnauthorized());
        }
        return Promise.reject(error);
    });
}
